export default "__VITE_ASSET__783612dc__"